import React, { useEffect, useState } from "react";
import RadioButton from "@components/atoms/RadioButton";
import Spacer from "@components/atoms/Spacer";
import { SpaceType } from "@components/atoms/Spacer/types";
import styled from "styled-components/native";
import useScreenOptionsHooks from "../../../../hooks/useScreenOptionsHooks";
import { RadioSelectType } from "./types";
import { resetFormForInputs } from "../utils";
import { useTranslation } from "react-i18next";
import { DefaultTheme } from "styled-components/native";

const RadioSelect = ({
  productType,
  options = [],
  onOptionChange,
  values,
  setValue,
  setRequestFormValue,
  setSingleRequestFormValue,
  itemDetail,
  selectedValue,
  resetRequestFormValue,
  formInputs,
  testID,
  valueKey = "radioSelect",
}: RadioSelectType) => {
  const { t } = useTranslation();
  const { theme, typography } = useScreenOptionsHooks();
  const stackOptions = theme.isMobile && options.length > 2;
  const [selectedOption, setSelectedOption] = useState(
    selectedValue || options[0].key
  );
  const handleSelect = (option: any) => {
    const isShareMethodChange =
      valueKey === "radioSelect" &&
      !!option?.key &&
      selectedOption !== option.key;
    setSelectedOption(option?.key);
    onOptionChange(option?.nestedInput);
    setValue(valueKey, option?.key);
    resetFormForInputs(formInputs, resetRequestFormValue, setValue);
    if (isShareMethodChange) {
      setValue?.("company_locations", []);
      setRequestFormValue?.("company_locations", []);
    }
    if (Object?.keys?.(itemDetail)?.length > 0) {
      setSingleRequestFormValue(itemDetail.id, valueKey, option?.key);
    } else {
      setRequestFormValue(valueKey, option?.key);
    }
  };
  useEffect(() => {
    setTimeout(() => {
      if (!values?.[valueKey]) {
        setValue(valueKey, options[0].key);
        setRequestFormValue(valueKey, options[0].key);
        if (itemDetail?.id) {
          setSingleRequestFormValue(itemDetail.id, valueKey, options[0].key);
        } else {
          setRequestFormValue(valueKey, options[0].key);
        }
      } else {
        handleSelect(options.find((item) => item.key === selectedValue));
      }
    }, 500);
  }, []);
  return (
    <RadioButtonContainer stack={stackOptions}>
      {options.map((option, index) => (
        <React.Fragment key={option.key ?? index}>
          <ViewContainer
            selected={selectedOption === option.key}
            productType={productType}
            stack={stackOptions}
            testID={testID + "." + option.key}
            data-testId={testID + "." + option.key}
          >
            <RadioButton
              label={t(option.label)}
              checked={selectedOption === option.key}
              onPress={() => handleSelect(option)}
              margin={stackOptions ? "0" : undefined}
              labelColor={
                selectedOption === option.key
                  ? theme["core-05"]
                  : theme["core-06"]
              }
              styles={
                selectedOption === option.key
                  ? typography["Body-M"]
                  : typography["Body-R"]
              }
            />
          </ViewContainer>
          {index < options.length - 1 && <Spacer size={SpaceType.Basic} />}
        </React.Fragment>
      ))}
    </RadioButtonContainer>
  );
};

const RadioButtonContainer = styled.View<{
  stack?: boolean;
}>`
  flex-direction: ${({ stack }: { stack?: boolean }) =>
    stack ? "column" : "row"};
  justify-content: space-between;
  align-items: ${({ stack }: { stack?: boolean }) =>
    stack ? "stretch" : "center"};
`;

const ViewContainer = styled.View<{
  selected: boolean;
  productType?: any;
  stack?: boolean;
}>`
  flex: ${({ stack }: { stack?: boolean }) => (stack ? "none" : 1)};
  width: ${({ stack }: { stack?: boolean }) => (stack ? "100%" : "auto")};
  background-color: ${({ theme }: { theme: DefaultTheme }) => theme["core-02"]};
  border-color: ${({
    theme,
    selected,
    productType,
  }: {
    theme: DefaultTheme;
    selected: boolean;
    productType: any;
  }) =>
    selected
      ? productType === "diamond"
        ? theme["diam-01"]
        : productType === "gemstone"
        ? theme["gem-01"]
        : productType === "jewelry"
        ? theme["jewelry-01"]
        : theme["lab-01"]
      : theme["core-02"]};
  border-width: 1px;
  padding-top: ${SpaceType.Basic}px;
  padding-bottom: ${SpaceType.Basic}px;
  padding-left: ${SpaceType.Double}px;
  padding-right: ${SpaceType.Double}px;
  border-radius: ${SpaceType.Basic}px;
`;

export default RadioSelect;
